<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <!-- Info -->
              <div class="card">
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="border-bottom mb-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3 suggestions-container">
                            <label class="form-label">
                              Organization Name
                              <span class="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              v-model="organizationName"
                              @input="fetchSuggestions"
                              @focus="showSuggestions = true"
                              @blur="hideSuggestions"
                              class="form-control"
                            />
                            <ul
                              v-if="showSuggestions && suggestions.length"
                              class="suggestions-list"
                            >
                              <li
                                v-for="(suggestion, index) in suggestions"
                                :key="index"
                                @mousedown.prevent="
                                  selectSuggestion(suggestion)
                                "
                              >
                                {{ suggestion }}
                              </li>
                            </ul>
                            <div
                              class="text-danger"
                              v-if="errors.organization_name"
                            >
                              {{ errors.organization_name[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Industry Type</label>
                            <multiselect
                              v-model="industryType"
                              :options="getFilteredOptions('industryTypes')"
                              track-by="name"
                              label="name"
                              placeholder="Select industry type"
                              @search-change="
                                (search) =>
                                  onSearchChange(search, industryTypes)
                              "
                            >
                            </multiselect>
                            <div
                              class="text-danger"
                              v-if="errors.industry_type"
                            >
                              {{ errors.industry_type[0] }}
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Phone </label>
                            <input
                              type="text"
                              v-model="phone"
                              class="form-control"
                            />
                            <div class="text-danger" v-if="errors.phone">
                              {{ errors.phone[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Address </label>
                            <input
                              type="text"
                              v-model="address"
                              class="form-control"
                            />
                            <div class="text-danger" v-if="errors.address">
                              {{ errors.address[0] }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">Website </label>
                            <input
                              type="text"
                              v-model="websiteLink"
                              class="form-control"
                            />
                            <div class="text-danger" v-if="errors.website_link">
                              {{ errors.website_link[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Exhibitions</label>
                            <multiselect
                              v-model="exhibitions"
                              :options="exhibitionsArr"
                              track-by="id"
                              label="name"
                              multiple="true"
                              placeholder="Select exhibitions"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div
                          v-for="(social, index) in socialNetworks"
                          :key="index"
                          class="col-md-12"
                        >
                          <div
                            class="card"
                            style="margin-bottom: unset !important"
                          >
                            <div class="card-header additional-header">
                              <div>Social Network {{ index + 1 }}</div>
                              <div>
                                <button
                                  class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeSocialNetworkInitial(index)"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Social Media
                                      </label>
                                      <multiselect
                                        v-model="social.mediaName"
                                        :options="socialMedias"
                                        track-by="name"
                                        label="name"
                                        placeholder="Select Social Media"
                                      >
                                      </multiselect>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          errors[
                                            `social_networks.${index}.mediaName`
                                          ]
                                        "
                                      >
                                        {{
                                          errors[
                                            `social_networks.${index}.mediaName`
                                          ][0]
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <label class="form-label"> URL </label>
                                    <input
                                      type="text"
                                      v-model="social.URL"
                                      class="form-control"
                                    />
                                    <div
                                      class="text-danger"
                                      v-if="
                                        errors[`social_networks.${index}.URL`]
                                      "
                                    >
                                      {{
                                        errors[
                                          `social_networks.${index}.URL`
                                        ][0]
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-2"
                        type="button"
                        @click="addSocialNetworks"
                      >
                        Add New Social Media
                        <i class="fas fa-plus icon-spacing"></i>
                      </button>

                      <div class="row mt-5">
                        <div
                          v-for="(person, index) in form.concern_person_info"
                          :key="index"
                          class="col-md-12"
                        >
                          <div class="card">
                            <div class="card-header additional-header">
                              <div>Concern Person {{ index + 1 }}</div>
                              <div>
                                <button
                                  class="btn btn-danger btn-sm"
                                  type="button"
                                  @click="removeConcernPerson(index)"
                                >
                                  Remove
                                  <i class="fas fa-trash icon-spacing"></i>
                                </button>
                              </div>
                            </div>
                            <div class="card-body">
                              <div class="mb-3">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Concern Person Name
                                        <span class="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="person.name"
                                      />
                                      <div
                                        class="text-danger"
                                        v-if="getErrorMessage(index, 'name')"
                                      >
                                        {{ getErrorMessage(index, "name") }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Phone <span class="text-danger">*</span>
                                      </label>
                                      <div class="phone-input-container">
                                        <div
                                          v-for="(
                                            phone, phoneIndex
                                          ) in person.phone"
                                          :key="phoneIndex"
                                          class="phone-tag"
                                        >
                                          {{ phone }}
                                          <span
                                            class="remove-phone"
                                            @click="
                                              removePhone(index, phoneIndex)
                                            "
                                            >&times;</span
                                          >
                                        </div>
                                        <input
                                          type="text"
                                          class="form-control phone-input"
                                          v-model="newPhone"
                                          @keydown="addPhone($event, index)"
                                          @blur="addPhoneOnBlur(index)"
                                          placeholder="Add phone number"
                                        />
                                      </div>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'phone') ||
                                          getErrorMessageComplex(index, 'phone')
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "phone") ||
                                          getErrorMessageComplex(index, "phone")
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label">
                                        Email<span class="text-danger">*</span>
                                      </label>
                                      <div class="phone-input-container">
                                        <div
                                          v-for="(
                                            email, emailIndex
                                          ) in person.email"
                                          :key="emailIndex"
                                          class="phone-tag"
                                        >
                                          {{ email }}
                                          <span
                                            class="remove-phone"
                                            @click="
                                              removeEmail(index, emailIndex)
                                            "
                                            >&times;</span
                                          >
                                        </div>
                                        <input
                                          type="text"
                                          class="form-control phone-input"
                                          v-model="newEmail"
                                          @keydown="addEmail($event, index)"
                                          @blur="addEmailOnBlur(index)"
                                          placeholder="Add email address"
                                        />
                                      </div>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'email') ||
                                          getErrorMessageComplex(index, 'email')
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "email") ||
                                          getErrorMessageComplex(index, "email")
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Date Of Birth</label
                                      >
                                      <Datepicker
                                        v-model="person.dob"
                                        :range="false"
                                        :clearable="true"
                                        :format="format"
                                        placeholder="Select a date"
                                      />
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'dob') ||
                                          getErrorMessageComplex(index, 'dob')
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "dob") ||
                                          getErrorMessageComplex(index, "dob")
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="form-label"
                                        >Designation</label
                                      >
                                      <multiselect
                                        v-model="person.designation"
                                        :options="
                                          getFilteredOptions('designations')
                                        "
                                        track-by="name"
                                        label="name"
                                        placeholder="Select department"
                                        @search-change="
                                          (search) =>
                                            onSearchChange(search, designations)
                                        "
                                        :allow-empty="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Influencing Role</label
                                      >
                                      <multiselect
                                        v-model="person.role"
                                        :options="roles"
                                        track-by="name"
                                        label="name"
                                        placeholder="Select role"
                                      >
                                      </multiselect>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Department</label
                                      >
                                      <multiselect
                                        v-model="person.department"
                                        :options="
                                          getFilteredOptions('departments')
                                        "
                                        track-by="name"
                                        label="name"
                                        placeholder="Select department"
                                        @search-change="
                                          (search) =>
                                            onSearchChange(search, departments)
                                        "
                                      >
                                      </multiselect>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Gender</label
                                      >

                                      <select
                                        class="form-control"
                                        v-model="person.gender"
                                      >
                                        <option value="" disabled="true">
                                          select gender
                                        </option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="others">Others</option>
                                      </select>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(index, 'gender') ||
                                          getErrorMessageComplex(
                                            index,
                                            'gender'
                                          )
                                        "
                                      >
                                        {{
                                          getErrorMessage(index, "gender") ||
                                          getErrorMessageComplex(
                                            index,
                                            "gender"
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="mb-3">
                                      <label class="col-form-label"
                                        >Attachment Visiting Card
                                      </label>
                                      <input
                                        type="file"
                                        class="form-control"
                                        @change="
                                          handleFileUpload($event, index)
                                        "
                                      />
                                      <!-- Show existing file name -->
                                      <div
                                        v-if="
                                          form.concern_person_info[index]
                                            .attachment
                                        "
                                        class="mt-2"
                                      >
                                        <span class="badge bg-success">
                                          Current File:
                                          {{
                                            form.concern_person_info[index]
                                              .attachment
                                          }}
                                        </span>
                                      </div>
                                      <div
                                        class="text-danger"
                                        v-if="
                                          getErrorMessage(
                                            index,
                                            'attachment'
                                          ) ||
                                          getErrorMessageComplex(
                                            index,
                                            'attachment'
                                          )
                                        "
                                      >
                                        {{
                                          getErrorMessage(
                                            index,
                                            "attachment"
                                          ) ||
                                          getErrorMessageComplex(
                                            index,
                                            "attachment"
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div
                                    v-for="(
                                      social, socialIndex
                                    ) in person.social_networks"
                                    :key="socialIndex"
                                    class="col-md-12"
                                  >
                                    <div
                                      class="card"
                                      style="margin-bottom: unset !important"
                                    >
                                      <div
                                        class="card-header additional-header"
                                      >
                                        <div>
                                          Social Network {{ socialIndex + 1 }}
                                        </div>
                                        <div>
                                          <button
                                            class="btn btn-danger btn-sm"
                                            type="button"
                                            @click="
                                              removeSocialNetwork(
                                                index,
                                                socialIndex
                                              )
                                            "
                                          >
                                            Remove
                                            <i
                                              class="fas fa-trash icon-spacing"
                                            ></i>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="card-body">
                                        <div class="">
                                          <div class="row">
                                            <div class="col-md-6">
                                              <div class="mb-3">
                                                <label class="form-label">
                                                  Social Media
                                                </label>
                                                <select
                                                  class="form-control"
                                                  v-model="social.social_media"
                                                >
                                                  <option
                                                    value=""
                                                    disabled="true"
                                                  >
                                                    select social type
                                                  </option>
                                                  <option value="facebook">
                                                    Facebook
                                                  </option>
                                                  <option value="youtube">
                                                    YouTube
                                                  </option>
                                                  <option value="linkedin">
                                                    LinkedIn
                                                  </option>
                                                  <option value="other">
                                                    Other
                                                  </option>
                                                </select>
                                                <div
                                                  class="text-danger"
                                                  v-if="
                                                    getErrorMessageUrl(
                                                      index,
                                                      'social_networks',
                                                      socialIndex,
                                                      'social_media'
                                                    )
                                                  "
                                                >
                                                  {{
                                                    getErrorMessageUrl(
                                                      index,
                                                      "social_networks",
                                                      socialIndex,
                                                      "social_media"
                                                    )
                                                  }}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-6">
                                              <label class="form-label">
                                                URL
                                              </label>
                                              <input
                                                type="text"
                                                class="form-control"
                                                v-model="social.url"
                                              />
                                              <div
                                                class="text-danger"
                                                v-if="
                                                  getErrorMessageUrl(
                                                    index,
                                                    'social_networks',
                                                    socialIndex,
                                                    'url'
                                                  )
                                                "
                                              >
                                                {{
                                                  getErrorMessageUrl(
                                                    index,
                                                    "social_networks",
                                                    socialIndex,
                                                    "url"
                                                  )
                                                }}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <button
                                  class="btn btn-primary btn-sm mb-2"
                                  type="button"
                                  @click="addNewSocialNetwork(index)"
                                >
                                  Add New Social Media
                                  <i class="fas fa-plus icon-spacing"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        class="btn btn-primary btn-sm mb-3"
                        type="button"
                        @click="addNewConcernPerson"
                      >
                        Add Another Concern Person
                      </button>
                    </div>

                    <div class="btn-list">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        style="float: right"
                        :disabled="isLoading"
                      >
                        Save Changes
                        <span
                          v-if="isLoading"
                          class="spinner-border spinner-border-sm ms-2"
                        ></span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /Info -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import http from "@/utils/http";
export default {
  components: {
    Multiselect,
    Datepicker,
  },
  data() {
    return {
      title: "Stackholder Update",
      format: "yyyy-MM-dd",
      isLoading: false,
      errors: {},
      suggestions: [],
      showSuggestions: false,

      stackholderId: null,
      targetId: null,
      designations: [],
      departments: [],
      roles: [],
      exhibitionsArr: [],

      form: {
        concern_person_info: [
          {
            name: "",
            phone: [],
            email: [],
            dob: "",
            designation: null,
            role: null,
            department: null,
            gender: "",
            attachment: "",
            social_networks: [
              {
                social_media: "",
                url: "",
              },
            ],
          },
        ],
      },
      newPhone: "",
      newEmail: "",

      designationCustomValue: null,
      roleCustomValue: null,
      departmentCustomValue: null,
      industryTypeCustomValue: null,

      //initial info
      organizationName: "",
      industryTypes: [],
      industryType: null,

      informationSources: [],
      filteredInfoSources: [],
      informationSourceQuery: "",
      informationSourceId: null,
      debounceTimeout: null,

      phone: "",
      address: "",

      countries: [],
      countryID: "",
      divisions: [],
      divisionID: "",
      districts: [],
      districtID: "",
      zones: [],
      zoneID: "",

      websiteLink: "",

      exhibitions: [],
      employees: [],
      projects: [],

      socialNetworks: [{ mediaName: "", URL: "" }],
      socialMedias: [
        { id: 1, name: "Facebook" },
        { id: 2, name: "Instagram" },
        { id: 3, name: "Twiter" },
        { id: 4, name: "linkedin" },
      ],
    };
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler(newId) {
        console.log("Route ID changed:", newId);
        this.stackholderId = newId;
      },
    },
    selectedDesignation: {
      handler(newValues) {
        newValues.forEach((value, index) => {
          console.log("new vlaue", value);
          this.form.concern_person_info[index].designation = value;
        });
      },
      deep: true,
    },
    industryType(newVal, oldVal) {
      console.log("new vlaue industry", newVal);
      console.log("old vlaue", oldVal);
    },
    // Watch the entire form object
    form: {
      handler(newValue, oldValue) {
        console.log("Form updated:", newValue);
        console.log("Previous state:", oldValue);
      },
      deep: true, // Ensures that nested objects are tracked
    },

    //initial
    countryID(newValue) {
      if (newValue) {
        this.getDivisionsByCountry();
      }
    },
    divisionID(newValue) {
      if (newValue) {
        this.getDistrictsByDivision();
      }
    },
    districtID(newValue) {
      if (newValue) {
        this.getZonesByDistrict();
      }
    },
  },
  computed: {
    getFilteredOptions() {
      return (source) => {
        let options = [];
        if (source === "designations") {
          options = this.designations;
        } else if (source === "departments") {
          options = this.departments;
        } else if (source === "industryTypes") {
          options = this.industryTypes;
        }

        // Add custom value for designations if it exists
        if (source === "designations" && this.designationCustomValue) {
          options = [{ id: null, name: this.designationCustomValue }].concat(
            options
          );
        } else if (source === "departments" && this.departmentCustomValue) {
          options = [{ id: null, name: this.departmentCustomValue }].concat(
            options
          );
        } else if (source === "industryTypes" && this.industryTypeCustomValue) {
          options = [{ id: null, name: this.industryTypeCustomValue }].concat(
            options
          );
        }

        return options;
      };
    },
  },
  mounted() {
    this.getProspectInfo();
    this.getDepartments();
    this.getDesignations();
    this.getRoles();
    this.getExhibitions();
    this.getIndustryTypes();
  },
  methods: {
    async submitForm() {
      this.isLoading = true;
      const endpoint = `/stackholders/${this.stackholderId}`;
      const method = "put";

      let body = {
        organization_name: this.organizationName ? this.organizationName : "",
        industryType: this.industryType ? this.industryType : null,
        industry_id: this.industryType ? this.industryType.id : null,
        phone: this.phone,
        address: this.address,
        website_link: this.websiteLink,
        exhibitions: this.exhibitions,
        social_networks: this.socialNetworks,
        concern_person_info: this.form.concern_person_info,
      };

      try {
        const response = await http[method](endpoint, body);

        this.$toast.success(response.data?.message);
        this.$router.push("/prospects");
      } catch (error) {
        if (error.response && error.response?.data?.message) {
          this.$toast.error(error.response?.data?.message);
        }
        if (error.response && error.response?.data?.errors) {
          this.errors = error.response?.data?.errors;
        }
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    getErrorMessage(index, field) {
      const key = `concern_person_info.${index}.${field}`;
      return this.errors[key] ? this.errors[key][0] : null;
    },
    getErrorMessageComplex(index, field) {
      const regex = new RegExp(
        `^concern_person_info\\.${index}\\.${field}\\.[0-9]+$`
      );

      for (const key in this.errors) {
        if (regex.test(key)) {
          return this.errors[key][0];
        }
      }

      return null;
    },
    getErrorMessageUrl(index, field, subIndex, subField) {
      const key = `concern_person_info.${index}.${field}.${subIndex}.${subField}`;
      return this.errors[key] ? this.errors[key][0] : null;
    },

    onSearchChange(search, optionsArray) {
      const exists = optionsArray.some(
        (option) => option.name.toLowerCase() === search.toLowerCase()
      );

      // Determine which custom value to update
      if (optionsArray === this.designations) {
        if (!exists && search.trim()) {
          this.designationCustomValue = search; // Update designation custom value
        } else {
          this.designationCustomValue = null;
        }
      } else if (optionsArray === this.departments) {
        if (!exists && search.trim()) {
          this.departmentCustomValue = search; // Update department custom value
        } else {
          this.departmentCustomValue = null;
        }
      } else if (optionsArray === this.industryTypes) {
        if (!exists && search.trim()) {
          this.industryTypeCustomValue = search; // Update role custom value
        } else {
          this.industryTypeCustomValue = null;
        }
      }
    },
    //search end
    addNewConcernPerson() {
      this.form.concern_person_info.push({
        name: "",
        phone: [],
        email: [],
        dob: "",
        designation: null,
        role: null,
        department: null,
        gender: "",
        attachment: "",
        social_networks: [
          {
            social_media: "",
            url: "",
          },
        ],
      });
    },
    //organization name suggestion
    async fetchSuggestions() {
      const endpoint = `/organizations-suggestions?q=${this.organizationName}`;
      const method = "get";
      if (this.organizationName.length > 1) {
        try {
          const response = await http[method](endpoint);
          this.suggestions = response.data?.contents;
        } catch (error) {
          //
        }
      } else {
        this.suggestions = [];
      }
    },
    selectSuggestion(suggestion) {
      this.organizationName = suggestion;
      this.showSuggestions = false;
    },
    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },

    //get departments, designations, roles
    async getDepartments() {
      const endpoint = `/departments`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.departments = response.data.contents.map((department) => ({
          id: department.id,
          name: department.name,
        }));
      } catch (error) {
        //
      }
    },
    async getDesignations() {
      const endpoint = `/designations`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.designations = response.data.contents.map((designation) => ({
          id: designation.id,
          name: designation.name,
        }));
      } catch (error) {
        //
      }
    },
    async getRoles() {
      const endpoint = `/influencing-roles`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.roles = response.data.contents.map((role) => ({
          id: role.id,
          name: role.name,
        }));
      } catch (error) {
        //
      }
    },
    async getExhibitions() {
      const endpoint = `/exhibitions`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.exhibitionsArr = response.data?.contents.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        //
      }
    },
    async getProspectInfo() {
      const endpoint = `/stackholders/${this.stackholderId}`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        console.log("response:", response.data.contents);

        this.form.concern_person_info =
          response.data?.contents?.concern_person_info;

        //initial
        this.organizationName = response.data?.contents?.organization_name;
        this.industryType = response.data.contents?.industry
          ? {
              id: response.data.contents?.industry?.id,
              name: response.data.contents?.industry?.type,
            }
          : null;

        this.phone = response.data?.contents?.phone;
        this.address = response.data?.contents?.address;
        this.websiteLink = response.data?.contents?.website_link;
        this.exhibitions = response.data?.contents?.exhibitions;
        this.socialNetworks = response.data?.contents?.social_networks;
      } catch (error) {
        //
      }
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0]; // Get the first selected file
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        // Send the file to the backend
        http
          .post("/upload-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.success) {
              // Save the file name returned from the backend
              this.form.concern_person_info[index].attachment =
                response.data.file_name;
            }
          })
          .catch((error) => {
            this.$toast.error(error.response.data.errors.file[0]);
          });
      }
    },

    removeConcernPerson(index) {
      this.form.concern_person_info.splice(index, 1);
    },

    addNewSocialNetwork(index) {
      this.form.concern_person_info[index].social_networks.push({
        social_media: "",
        url: "",
      });
    },

    removeSocialNetwork(index, socialIndex) {
      this.form.concern_person_info[index].social_networks.splice(
        socialIndex,
        1
      );
    },

    addPhone(event, index) {
      if (event.key === "Enter" || event.key === "Tab") {
        event.preventDefault();

        const phone = this.newPhone.trim();

        if (
          phone &&
          !this.form.concern_person_info[index].phone.includes(phone)
        ) {
          this.form.concern_person_info[index].phone.push(phone);
          this.newPhone = ""; // Clear the input
        }
      }
    },
    addPhoneOnBlur(index) {
      const phone = this.newPhone.trim();
      if (
        phone &&
        !this.form.concern_person_info[index].phone.includes(phone)
      ) {
        this.form.concern_person_info[index].phone.push(phone);
        this.newPhone = ""; // Clear the input
      }
    },

    removePhone(index, phoneIndex) {
      this.form.concern_person_info[index].phone.splice(phoneIndex, 1);
    },

    addEmail(event, index) {
      if (event.key === "Enter" || event.key === "Tab") {
        event.preventDefault();

        const email = this.newEmail.trim();

        if (
          email &&
          !this.form.concern_person_info[index].email.includes(email)
        ) {
          this.form.concern_person_info[index].email.push(email);
          this.newEmail = "";
        }
      }
    },
    addEmailOnBlur(index) {
      const email = this.newEmail.trim();

      if (
        email &&
        !this.form.concern_person_info[index].email.includes(email)
      ) {
        this.form.concern_person_info[index].email.push(email);
        this.newEmail = "";
      }
    },

    removeEmail(index, emailIndex) {
      this.form.concern_person_info[index].email.splice(emailIndex, 1);
    },

    //initial info
    async getIndustryTypes() {
      try {
        const response = await http.get("industries");
        console.log("industry type: " + this.industryType);
        this.industryTypes = response.data.contents.map((industry) => ({
          id: industry?.id,
          name: industry?.type,
        }));
      } catch (error) {
        console.error("Error:", error);
      }
    },
    addSocialNetworks() {
      this.socialNetworks.push({
        mediaName: "",
        URL: "",
      });
    },

    removeSocialNetworkInitial(index) {
      this.socialNetworks.splice(index, 1);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.present-address-header {
  background: #a2c0d3 !important;
  color: #000 !important;
}
.suggestions-container {
  position: relative; /* Ensures dropdown stays within this container */
}

.suggestions-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  position: absolute;
  background: white;
  width: 100%; /* Matches input field width */
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000; /* Ensures it appears above other elements */
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.suggestions-list li {
  padding: 8px;
  cursor: pointer;
}

.suggestions-list li:hover {
  background: #f0f0f0;
}
</style>
